import { IToken } from '@/interface'

export const TOKENS: IToken[] = []
export const tokenAddressMap: Record<string, IToken> = {}

export const tokenSymbolMap: Record<string, IToken> = {}
